/**
 * @fileoverview Organisation data source and type definitions.
 */

import { OrganisationSchema, type Organisation } from '@schema/index';
import { createBaseDataSource } from './base-data-source';
import { createAccountTrackingFields, createCreatedAtField, createDeletedAtField, createLookupEntityFields, createStringField, createUpdatedAtField, FIELD_TYPE_WIDTHS, FIELD_WIDTHS } from './field-factories';
import { getCache } from './cache-registry';

export type { Organisation };

export const organisationDataSource = createBaseDataSource<Organisation>({
  endpoint: 'organisation',
  searchField: 'name',
  schema: OrganisationSchema,
  fields: [
    ...createLookupEntityFields(),
    createStringField('website', 'Website', FIELD_WIDTHS.LARGE),
    createStringField('email', 'Email', FIELD_TYPE_WIDTHS.EMAIL),
    createStringField('phone', 'Phone', FIELD_WIDTHS.MEDIUM),
    createStringField('logo', 'Logo', FIELD_WIDTHS.LARGE),
    ...createAccountTrackingFields(),
    createCreatedAtField(),
    createUpdatedAtField(),
    createDeletedAtField(),
  ],
});

export const organisationCache = getCache('organisation');
